import SystemHealthScreen from './SystemHealthScreen.vue';

export default {
    SystemHealthScreen,
};